module.exports = __webpack_public_path__ + "632be2ccacbc5b0e102406bffd09e1f2.png";